import JSONPath from "JSONPath";
export const getBrandNameFromGems = (categoryId, categories) => {
  // console.log("categories", categories, categoryId);
  // console.log(categoryId);
  const brandName = categories.find(cat => cat.categoryId === Number(categoryId))?.categoryName;
  return brandName || "";
};

export const getCategoriesFromSpuIds = spuIds => {
  const categories = [];
  JSONPath(null, "$.data[*].categories", spuIds).forEach(item => {
    item.forEach(sub => {
      categories.push(sub);
    });
  });
  return categories;
};
